export const BASE_API_URL = "http://localhost:5000/api/client";
export const BASE_DOC_URL = "http://localhost:5000";
